import { AuthService } from 'services/AuthService';

const authService = new AuthService();

const getClients = async (
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    setRows: React.Dispatch<React.SetStateAction<ClientTableRow[]>>,
) => {
    try {
        setLoading(true);

        const response = await authService.client.getClients();
        const clients = (response ?? []).map((client) => {
            const redirectUri = Array.isArray(client.redirect_uri)
                ? client.redirect_uri.join(', ')
                : (client.redirect_uri ?? '-');

            const scope = Array.isArray(client.scope)
                ? client.scope.join(' ')
                : (client.scope ?? '-');

            return {
                id: client.client_id,
                client_id: client.client_id,
                name: client.name,
                owner_id: client.owner_id ?? '-',
                grant_types: (client.grant_types ?? []).join(', '),
                scope,
                redirect_uri: redirectUri,
            };
        });

        setRows(clients);
    } catch (error: any) {
        console.error('Error fetching clients:', error?.message || error);
        setRows([]);
    } finally {
        setLoading(false);
    }
};

const deleteClients = async (
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    clientIds: string[],
) => {
    try {
        setLoading(true);
        await Promise.all(clientIds.map((clientId) => authService.client.deleteClient(clientId)));
        return true;
    } catch (error: any) {
        console.error('Error deleting clients:', error?.message || error);
        return false;
    } finally {
        setLoading(false);
    }
};

const createClient = async (payload: ClientCreatePayload): Promise<ClientCreateResult> => {
    return await authService.client.createClient(payload);
};

const getScopePermissions = async (): Promise<Permission[]> => {
    return await authService.permission.getPermissions();
};

export {
    getClients,
    deleteClients,
    createClient,
    getScopePermissions,
};
